import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';

export const SanityComparisonTable = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('comparisonTable'),
  _key: z.string(),
  title: z.string(),
  headers: z.array(z.string()),
  rows: z.array(
    z.object({
      _key: z.string(),
      featureLabel: z.string(),
      featureContent: SanityBasicText,
      cells: z.array(
        z.object({
          _key: z.string(),
          isEmpty: z.boolean().optional().nullable(),
          icon: z.enum(['Checkmark', 'Dash']).optional().nullable(),
        }),
      ),
    }),
  ),
});
export type SanityComparisonTable = z.infer<typeof SanityComparisonTable>;

export const comparisonTable = groq`{
  _type,
  _key,
  title,
  headers,
  rows[] {
    _key,
    featureLabel,
    featureContent[] ${basicText},
    cells[] {
      _key,
      isEmpty,
      icon
    }
  }
}`;
